<template>
    <span>
        <!-- ****************    Menú lateral para pantallas medianas y grandes:     ***************************-->
        <v-navigation-drawer
            class="hidden-sm-and-down"
            clipped
            v-model="drawer"
            permanent
            app
            hide-overlay
            stateless
            color="grey lighten-4"
        >
            <v-list color="grey lighten-4">
                <v-list-item @click="onLogout">
                    <v-list-item-title class="indigo--text text--darken-3">
                        <v-icon color="indigo darken-3">mdi-exit-to-app</v-icon>&nbsp; Salir del Sistema
                    </v-list-item-title>
                </v-list-item>

                <v-list-item class="sip-blue">
                    <v-select
                        color="cyan darken-2"
                        v-model="selectedUser"
                        hint="Médico Seleccionado"
                        :items="selectUsers"
                        item-text="name"
                        item-value="id"
                        label="Seleccionar"
                        persistent-hint
                        return-object
                        single-line
                        @change="onSelectUser"
                    ></v-select>
                </v-list-item>

                <v-list-item>
                    <v-container fluid grid-list-xm>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card flat color="grey lighten-4">
                                    <v-card-actions>
                                        <v-text-field
                                            color="indigo darken-3"
                                            v-model="clienteABuscar"
                                            hint="nombre o apellido(s)"
                                            v-on:keyup.enter="navSearchClient(clienteABuscar)"
                                            :loading="searchingClients"
                                        >
                                            <template v-slot:label>
                                                Buscar paciente
                                                <v-icon style="vertical-align: middle">search</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-list-item>
                <v-list-item>
                    <v-container fluid grid-list-xm>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card :loading="searchingClients">
                                    <v-toolbar height="30" dark class="indigo darken-3" flat>
                                        <v-toolbar-title
                                            class="list-header"
                                        >Resultado de la búsqueda</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon @click="onClearClients" v-on="on">
                                                    <v-icon>clear_all</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Limpiar resultados</span>
                                        </v-tooltip>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        style="height: 110px; max-height: 110px"
                                        class="scroll-y"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group v-model="clientIndex" color="pink">
                                            <v-list-item
                                                v-for="(client, i) in navClients"
                                                :key="i"
                                                @click="onClient(client.id)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ client.lastName1 + " " + client.lastName2 + " " + client.name}}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-list-item>
                <v-list-item>
                    <v-container fluid grid-list-xm>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card :loading="searchingClients">
                                    <v-toolbar height="30" dark class="indigo darken-3" flat>
                                        <v-toolbar-title class="list-header">Expedientes abiertos</v-toolbar-title>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        style="height: 110px; max-height: 110px"
                                        class="scroll-y"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group v-model="clientIndex" color="pink">
                                            <v-list-item
                                                v-for="(patient, i) in openPatients"
                                                :key="i"
                                                @click="onPatient(patient.id)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ patient.lastName1 + " " + patient.lastName2 + " " + patient.name}}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-list-item>

                <v-list-item @click="onCalendar">
                    <v-list-item-title class="indigo--text text--darken-3">
                        <v-icon color="indigo darken-3">mdi-calendar</v-icon>&nbsp; Calendario
                    </v-list-item-title>
                </v-list-item>

                <v-list-item class="sip-blue" @click="onNewPatient" color="indigo darken-3">
                    <v-list-item-title class="indigo--text text--darken-3">
                        <v-icon color="indigo darken-3">mdi-account-plus</v-icon>&nbsp; Nuevo Paciente
                    </v-list-item-title>
                </v-list-item>

                <v-list-item class="sip-blue" @click="onDummyFunction">
                    <v-menu offset-x offset-y>
                        <template v-slot:activator="{ on }">
                            <v-list-item-title class="indigo--text text--darken-3" v-on="on">
                                <v-icon color="indigo darken-3">mdi-cog</v-icon>&nbsp; Herramientas
                            </v-list-item-title>
                        </template>
                        <v-list color="grey lighten-4">
                            <v-list-item @click="onContacts">
                                <v-list-item-title class="indigo--text text--darken-3">
                                    <v-icon color="indigo darken-3">mdi-doctor</v-icon>&nbsp; Médicos de Referencia
                                </v-list-item-title>
                            </v-list-item>

                            <v-list-item @click="onVaccines">
                                <v-list-item-title class="indigo--text text--darken-3">
                                    <v-icon color="indigo darken-3">mdi-eyedropper-variant</v-icon>&nbsp; Vacunas
                                </v-list-item-title>
                            </v-list-item>

                            <v-divider></v-divider>
                            <v-list-item @click="onDrugs">
                                <v-list-item-title class="indigo--text text--darken-3">
                                    <v-icon color="indigo darken-3">mdi-pill</v-icon>&nbsp; Medicamentos
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="onLabExams">
                                <v-list-item-title class="indigo--text text--darken-3">
                                    <v-icon color="indigo darken-3">mdi-clipboard-text</v-icon>&nbsp; Exámenes de Laboratorio
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="onIndications">
                                <v-list-item-title class="indigo--text text--darken-3">
                                    <v-icon color="indigo darken-3">mdi-folder-information</v-icon>&nbsp; Indicaciones
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-list-item>
            </v-list>

            <!-- <v-container fluid grid-list-xm class="pa-1">
                

                

                
            </v-container>-->

            <!-- <v-list dense class="pt-0">
                

               

               

                
            </v-list>-->
        </v-navigation-drawer>

        <!--**********************     Menú lateral para pantallas chicas:    ********************-->
        <!-- <v-navigation-drawer
      class="hidden-md-and-up"
      clipped
      v-model="drawer"
      app
      :mini-variant.sync="mini"
      hide-overlay
      stateless
    >
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-item avatar>
            <v-list-item-avatar>
              <img src="https://randomuser.me/api/portraits/men/85.jpg">
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{selectedUserName}}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon @click.stop="mini = !mini">
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-toolbar>

      <v-list class="pt-0" dense>
        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-icon>person_add</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Nuevo Cliente</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-icon>person_add</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <v-select
                v-model="asesorSeleccionado"
                hint="Asesor de Ventas"
                :items="asesores"
                item-text="nombre"
                item-value="id"
                label="Select"
                persistent-hint
                return-object
                single-line
              ></v-select>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-icon>directions_car</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Automóviles</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
        </v-navigation-drawer>-->
    </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    data() {
        return {
            drawer: true,
            clientIndex: -1, //Indice del cliente seleccionado.
            items: [
                { title: 'Nuevo Cliente', icon: 'person_add', index: 1 },
                { title: 'Automóviles', icon: 'directions_car', index: 2 }
            ],
            mini: true,
            right: null,
            type: 'month',
            start: '2019-01-01',
            end: '2019-01-06',
            typeOptions: [
                { text: 'Day', value: 'day' },
                { text: '4 Day', value: '4day' },
                { text: 'Week', value: 'week' },
                { text: 'Month', value: 'month' },
                { text: 'Custom Daily', value: 'custom-daily' },
                { text: 'Custom Weekly', value: 'custom-weekly' }
            ],
            rowsPerPageItems: [4, 8, 12],
            pagination: {
                rowsPerPage: 4
            },
            clienteABuscar: ''
        };
    },

    methods: {
        ...mapActions([
            'navSearchClient',
            'navClearClients',
            'setNewClient',
            'updateClientID',
            'initSaleFields',
            'getClientData',
            'getClientCars'
        ]),
        onLogout() {
            this.$store.dispatch('logout');
        },
        onNewPatient() {
            this.$router.push('/newpatient');
        },
        onDummyFunction() {
            //Función dummy para que el cursor del menú "Herramientas" cambie igual que los demás menús.
        },
        onContacts() {
            //this.$router.push('/users');
        },
        onVaccines() {
            //this.$router.push('/companies');
        },
        onDrugs() {
            //this.$router.push('/exchangerate');
        },
        onLabExams() {
            //this.$router.push('/functions');
        },
        onIndications() {
            //this.$router.push('/roles');
        },
        onClient(id) {
            this.$router.push('/patient');
        },
        onSelectUser() {
            console.log(
                'OnSelectUser, selected User: ',
                this.selectedUser.name
            );
        },
        onClearClients() {
            this.clienteABuscar = '';
            this.navClearClients();
        },
        onCalendar() {
            console.log('onCalendar...');
        }
    },
    computed: {
        ...mapGetters([
            'navAppTitle',
            'navMainLogo',
            'isAuthenticated',
            'selectedUserName',
            'navClients',
            'openPatients',
            'navAdvisors',
            'selectUsers',
            'waitCursor',
            'searchingClients'
        ]),
        waitCursorClients() {
            if (this.searchingClients) {
                return 'red';
            } else {
                return false;
            }
        },
        selectedUser: {
            get() {
                return this.$store.getters.selectedUser;
            },
            set(selectedUser) {
                this.$store.dispatch('updateSelectedUser', selectedUser);
            }
        }
    }
};
</script>

<style scoped>
.list-header {
    font-size: 13px;
    font-weight: bold;
}

.sip-blue {
    color: #283593;
    /* indigo darken-3 */
}
</style>
